<template>
  <div class="pb-1">
    <div v-if="this.loadpage == false" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <b-card v-if="this.loadpage == true" no-body>
      <b-card-header class="pb-0">
        <div>
          <b-img
            :src="require('@/assets/line/LINE_LOGO.png')"
            fluid
            width="45"
          />
          <span class="h4 pl-1">เชื่อมต่อ Line Notify</span>
        </div>
        <b-button variant="outline-success" v-b-modal.connect>
          <feather-icon icon="LinkIcon"/>
          เชื่อมต่อ LINE
        </b-button>
      </b-card-header>
      <hr class="pb-0">
      <!-- pc -->
      <b-card-body class="d-none d-sm-block">
        <h4 v-if="this.notifyList.length == 0" class="text-center">ไม่มีการเชื่อมต่อ Line</h4>
        <b-table
          v-else
          responsive
          :items="notifyList"
          :fields="notifyFields"
          bordered
          small
        >
        <!-- formatDatetime -->
          <template  #cell(created)="data">
            <div>{{formatDatetime(data.value)}}</div>
          </template>
          <template #cell(checkOrder)="data">
            <div v-if="data.value == true" class="text-center">
              <feather-icon class="icon" icon="CheckCircleIcon" size="25"/>
            </div>
          </template>
          <template #cell(arrivedChina)="data">
            <div v-if="data.value == true" class="text-center">
              <feather-icon class="icon" icon="CheckCircleIcon" size="25"/>
            </div>
          </template>
          <template #cell(arrivedThai)="data">
            <div v-if="data.value == true" class="text-center">
              <feather-icon class="icon" icon="CheckCircleIcon" size="25"/>
            </div>
          </template>
          <template #cell(notifyPayment)="data">
            <div v-if="data.value == true" class="text-center">
              <feather-icon class="icon" icon="CheckCircleIcon" size="25"/>
            </div>
          </template>
          <template #cell(notifyTracking)="data">
            <div v-if="data.value == true" class="text-center">
              <feather-icon class="icon" icon="CheckCircleIcon" size="25"/>
            </div>
          </template>
          <template #cell(id)="data">
            <feather-icon
              :id="`delete-icon-${data.value}`"
              icon="TrashIcon"
              class="cursor-pointer text-danger"
              size="20"
              @click="delNotify(data.value)"
            />
            <b-tooltip
              title="ลบ"
              :target="`delete-icon-${data.value}`"
              :delay="{show: '1500'}"
            />
          </template>
        </b-table>
      </b-card-body>
      <!-- mobile -->
      <b-card-body v-for="(item, index) in notifyList" :key="index" class="d-block d-sm-none py-0 px-0" role="tablist">
        <b-card-header class="pb-0" header-tag="header" role="tab">
          <b-container class="px-0">
            <div class="h5">{{formatDatetime(item.created)}}</div>
            <div>{{item.token}}</div>
            <div class="text-right">
              <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="flat-primary"
                class="btn-icon rounded-circle float-right pr-0"
                v-b-toggle="'list-'+index"
              >
                <span class="when-opened">
                  <feather-icon icon="ChevronUpIcon" />
                </span>
                <span class="when-closed">
                  <feather-icon icon="ChevronDownIcon" />
                </span>
              </b-button>
            </div>
          </b-container>
        </b-card-header>
        <b-collapse :id="'list-'+index" accordion="point" role="tabpanel">
          <b-card-body class="py-0">
            <h5 class="pl-1" v-if="item.checkOrder == true">- แจ้งเตือนตรวจออเดอร์เรียบร้อย</h5>
            <h5 class="pl-1"  v-if="item.arrivedChina == true">- แจ้งเตือนสินค้าเข้าโกดังจีน</h5>
            <h5 class="pl-1" v-if="item.arrivedThai == true">- แจ้งเตือนสินค้าเข้าโกดังไทย</h5>
            <h5 class="pl-1" v-if="item.notifyPayment == true">- แจ้งเตือนชำระเงินค่าขนส่ง</h5>
            <h5 class="pl-1" v-if="item.notifyTracking == true">- แจ้งเตือนเลข Tracking ส่งสินค้า</h5>
            <h5 class="text-right">
              <b-button	@click="delNotify(item.id)" class="btn-icon" variant="danger">
                <feather-icon class="icon" icon="Trash2Icon" size="15"/>
              </b-button>
            </h5>
          </b-card-body>
        </b-collapse>
        <hr class="pb-0">
      </b-card-body>
    </b-card>
    <b-modal
      id="connect"
      scrollable
      hide-footer
      title="เชื่อมต่อ line notify"
      title-class="h4"
      size="md"
      centered
    >
      <b-form class="pt-2">
        <b-card class="text-center container" style="width:75%" >
          <b-img
            :src="require('@/assets/logo-taobao/Profile.jpg')"
            fluid
            width="100"
          />
          <feather-icon class="ml-2 mr-1" icon="Link2Icon" size="20"/>
          <b-img
            :src="require('@/assets/line/LINE_NOTIFY.png')"
            fluid
            width="100"
          />
        </b-card>
        <div class="pl-5">
          <b-form-checkbox class="pb-1" v-model="checkOrder">แจ้งเตือนตรวจออเดอร์เรียบร้อย</b-form-checkbox>
          <b-form-checkbox class="pb-1" v-model="arrivedChina">แจ้งเตือนสินค้าเข้าโกดังจีน</b-form-checkbox>
          <b-form-checkbox class="pb-1" v-model="arrivedThai">แจ้งเตือนสินค้าเข้าโกดังไทย</b-form-checkbox>
          <b-form-checkbox class="pb-1" v-model="payment">แจ้งเตือนชำระเงินค่าขนส่ง</b-form-checkbox>
          <b-form-checkbox class="pb-1" v-model="tracking">แจ้งเตือนเลข Tracking ส่งสินค้า</b-form-checkbox>
        </div>
        <div class="text-center">
          <b-button class="h4" variant="success" @click="lineAuth()"><feather-icon icon="LinkIcon"/> เชื่อมต่อ LINE</b-button>
        </div>
      </b-form>
    </b-modal>

  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BButton, BImg, BSpinner, BRow, BCol, BModal, BForm, BContainer,
  BFormRadio, BFormRadioGroup, BFormCheckbox, BTable, BCollapse, BTooltip,
  VBModal, VBToggle
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { formatDatetime } from '@/views/global_function.js'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";
export default {
  name: 'Taobao2youLineNotify',

  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },

  components: {
    BCard, BCardHeader, BCardBody, BButton, BImg, BSpinner, BRow, BCol, BModal, BForm, BContainer,
    BFormRadio, BFormRadioGroup, BFormCheckbox, BTable, BCollapse, BTooltip,
    VBModal,VBToggle,
   },

  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      checkOrder: true,
      arrivedChina: true,
      arrivedThai: true,
      payment: true,
      tracking: true,
      sendId: 0,

      notifyList: [],
      notifyFields: [
        {key: 'token', label: 'Token', thStyle: { width: "5%" }},
        {key: 'created', label: 'วันที่สร้าง'},
        {key: 'checkOrder', label: 'ตรวจออเดอร์เรียบร้อย'},
        {key: 'arrivedChina', label: 'สินค้าเข้าโกดังจีน'},
        {key: 'arrivedThai', label: 'สินค้าเข้าโกดังไทย'},
        {key: 'notifyPayment', label: 'ชำระเงินค่าขนส่ง'},
        {key: 'notifyTracking', label: 'เลข Tracking ส่งสินค้า'},
        {key: 'id', label : 'ลบ', thClass: 'text-center', tdClass: 'text-center' }
      ],
      loadpage: false,
    };
  },

  created() {
    this.lineNotifyList()
  },

  methods: {
    formatDatetime,
    async lineAuth() {
      var keepdata = []
      var axios = require('axios');
      var data = JSON.stringify({
        "id": this.sendId,
        "loginToken": this.userData.data.customerInfo.loginToken,
        "notifyTracking": this.tracking,
        "arrivedThai": this.arrivedThai,
        "arrivedChina": this.arrivedChina,
        "checkOrder": this.checkOrder,
        "notifyPayment": this.payment
      });

      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'LineNotify/authorize',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
          'Content-Type': 'application/json'
        },
        data : data
      };
      await axios(config)
      .then(async function (response) {
        keepdata = response.data.result
      })
      .catch(function (error) {
        console.log(error);
      });
      
      if (keepdata) {
        window.open(keepdata,"_self");
      }
    },
    async lineNotifyList() {
      var keepdata = []
      var axios = require('axios');
      var data = JSON.stringify({
        "id": this.sendId,
        "loginToken": this.userData.data.customerInfo.loginToken,
      });

      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'LineNotify/get-line-notify-list',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
          'Content-Type': 'application/json'
        },
        data : data
      };
      await axios(config)
      .then(async function (response) {
        keepdata = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      this.notifyList = keepdata
      this.loadpage = true
    },
    async delNotify(id) {
      this.$swal({
        title: 'ยกเลิกรับการแจ้งเตือน ?',
        text: "คุณแน่ใจหรือป่าวว่าต้องการยกเลิกรับการแจ้งเตือนทาง Line Notify?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          var axios = require('axios');
          var data = JSON.stringify({
            "id": id,
            "loginToken": this.userData.data.customerInfo.loginToken,
          });

          var config = {
            method: 'post',
            url: taobaoService_dotnet + 'LineNotify/delete-line-notify',
            headers: {
              'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
              'Content-Type': 'application/json'
            },
            data : data
          };
          await axios(config)
          .then(async function (response) {
          })
          .catch(function (error) {
            console.log(error);
          });
          this.lineNotifyList()
        }
      })
    }
  }
};
</script>
<style scoped lang="scss">
.collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
      display: none;
  }
</style>